"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lightenColor = lightenColor;
function lightenColor(color, percent) {
  var hex = color.replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  var lighten = function lighten(value) {
    var amount = Math.round((255 - value) * (percent / 100));
    return Math.min(255, value + amount);
  };
  var newR = lighten(r);
  var newG = lighten(g);
  var newB = lighten(b);
  var toHex = function toHex(value) {
    return value.toString(16).padStart(2, '0');
  };
  return "#".concat(toHex(newR)).concat(toHex(newG)).concat(toHex(newB));
}